import { useMemo, useCallback } from "react";
import { countryList } from "../constants/lists";
import { getAllowedMarkets } from '../utils/rolesUtils';

export const useCountries = () => {
    /**
     * - A memoized list of countries filtered by the allowed markets.
     * Each country is represented as an object with `code` (country code) and `label` (country name).
     */
    const countries = useMemo(() => {
        const allowedMarkets = getAllowedMarkets();
        const result: { code: string; label: string }[] = [];
        Object.entries(countryList).forEach(([code, name]) => {
            // If length is 0 then user is an admin
            if (allowedMarkets.length === 0 || allowedMarkets.includes(code))
            result.push({ code, label: name });
        });
      return result;
    }, []);

    const getCountryLabel = useCallback((code: string) => {
        const country = countries.find((c) => c.code === code);
        return country ? country.label : code;
    }, [countries]);

    const getCountryCodes = useCallback(
        (names: string | string[]) => {

        const findCode = (val: string) => {

            let country = countries.find((c) => c.code === val);
                if (country) {
                return country.code;
                }

                country = countries.find((c) => c.label === val);
                if (country) {
                return country.code;
                }

                return null;
            };

            if (typeof names === "string") {
                return findCode(names);
            }

            // Array of values
            return names.map((name) => findCode(name));
        },
        [countries]
    );

    const getMarketLabels = useCallback((markets: string[]) => {
        return markets.map((market) => {
            const country = countries.find(
                (c) => c.code === market || c.label === market
            );
            return country ? country.label : market;
        });
    }, [countries]);

    const displayMarketOptions = useCallback((markets: string[], filterUnallowedMarkets = false) => {
        if(filterUnallowedMarkets) {
            const allowedMarkets = getAllowedMarkets();
            markets = markets.filter((market) => allowedMarkets.includes(market));
        }
        return markets.map((market) => {
            const country = countries.find((c) => c.code === market || c.label === market);
            return {
                value: country?.code || market,
                label: country?.label || market,
            };
        });
    }, [countries]);

    return { countries, getCountryLabel, getCountryCodes, getMarketLabels, displayMarketOptions };
};
